import { useChatContext } from '@almai1/chatbot-widget'
import type { UICustomContentPart } from '@almai1/chatbot-core'

interface SuggestionButtonsData {
  buttons: { text: string; action: string }[]
}

interface UseSuggestionButtonsResult {
  hasSuggestionButtons: boolean
  buttonsData: SuggestionButtonsData | null
}

/**
 * Hook to detect if suggestion buttons are currently visible in the chat.
 * Returns both the visibility state and the button data.
 */
export function useHasSuggestionButtons(): UseSuggestionButtonsResult {
  const { messages } = useChatContext()

  // Find the last suggestion_buttons and check if user already responded
  let buttonsData: SuggestionButtonsData | null = null
  let lastButtonsIndex = -1

  for (let i = 0; i < messages.length; i++) {
    const msg = messages[i]
    const customPart = msg.contentParts.find(
      (p: { $type: string }): p is UICustomContentPart =>
        p.$type === 'UICustomContentPart' &&
        (p as UICustomContentPart).elementName === 'suggestion_buttons'
    )
    if (customPart) {
      buttonsData = customPart.data as SuggestionButtonsData
      lastButtonsIndex = i
    }
  }

  // Hide if user already responded after the buttons
  if (lastButtonsIndex >= 0) {
    for (let i = lastButtonsIndex + 1; i < messages.length; i++) {
      if (messages[i].isUser) {
        buttonsData = null
        break
      }
    }
  }

  return {
    hasSuggestionButtons: buttonsData !== null,
    buttonsData,
  }
}
